'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var memoize = function memoize() {
  for (var _len = arguments.length, selectors = Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  var compute = selectors.pop();
  // If no initial selector is provided other than compute, assume we just
  // want to memoize on state
  if (!selectors.length) selectors.push(function (state) {
    return state;
  });
  var previousSelectorResults = [];
  var previousComputeResult = void 0;

  var len = selectors.length;

  return function () {
    var current = [];
    var unchanged = true;
    for (var i = 0; i < len; i++) {
      (current[i] = selectors[i].apply(null, arguments)) !== previousSelectorResults[i] && (unchanged = false);
    }

    previousSelectorResults = current;
    if (unchanged) return previousComputeResult;
    return previousComputeResult = compute.apply(null, current);
  };
};

var memoizeHandlerAs = function memoizeHandlerAs(handler) {
  var keyed = new Map();

  return function (key) {
    return function (state) {
      if (key && typeof key === 'function') key = key(state);
      if (!keyed.has(key)) keyed.set(key, handler(key));

      return keyed.get(key)(state);
    };
  };
};

var memoizeAs = function memoizeAs() {
  for (var _len2 = arguments.length, selectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    selectors[_key2] = arguments[_key2];
  }

  return memoizeHandlerAs(function (key) {
    selectors = selectors.map(function (selector) {
      return function () {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return selector.apply(undefined, args.concat([key]));
      };
    });
    return memoize.apply(undefined, _toConsumableArray(selectors));
  });
};

module.exports = Object.freeze({
  memoize: memoize,
  memoizeHandlerAs: memoizeHandlerAs,
  memoizeAs: memoizeAs
});